import { getConsentsForPulse } from '@vgtv/consent-manager';
import type { Tracker } from '@schibsted/pulse-sdk';
import type { Player } from '@schibsted-svp/web-player';

import { getConfigProvider } from '../../../utils/player/player';

export const getPulseTracker = async (player: Player) => {
  let tracker: Tracker | null = null;

  const plugin = player.getPlugin('PulseStats');
  if (plugin) {
    tracker = await plugin.getTrackerOrNull();
  }

  if (!tracker && window.pulse) {
    const provider = getConfigProvider(player);
    const trackerId = `svp-tracker-${provider}`;
    window.pulse(
      'init',
      provider,
      { consents: getConsentsForPulse() },
      undefined,
      trackerId
    );

    tracker = await new Promise<Tracker>((resolve) => {
      window.pulse!(trackerId, (t) => {
        resolve(t);
      });
    });
  }

  return tracker;
};
